<template>
    <div class="recommend" v-if="data && data.length > 0">
        <div class="recommend-cell" v-for="(item, index) in data" :key="index">
            <div class="recommend-cell-right">
                <p class="recommend-cell-right-price">{{ item.amount }}</p>
                <p class="recommend-cell-right-max" v-if="item.couponType == 5">最高</p>
            </div>
            <div class="recommend-cell-left">
                <div class="recommend-cell-left-info">
                    <p class="recommend-cell-left-info-name van-multi-ellipsis--l2">{{ item.name }}<span
                            v-if="item.rule"><van-icon name="question-o" @click="ruleEvent(item.rule)" /></span></p>
                    <p class="recommend-cell-left-info-limit van-multi-ellipsis--l2">满{{ item.limit }}元可用</p>
                </div>
                <div class="recommend-cell-left-btn" @click="go(item)">去领券</div>
            </div>
        </div>

        <van-popup class="pop" v-model="ruleFlag" :close-on-click-overlay="false">
            <div class="content">
                <div class="content-title">优惠券说明</div>
                <div class="content-rule" v-html="rule"></div>
            </div>
            <van-icon class="close" name="close" color="white" size="34" @click.stop="ruleFlag = false" />
        </van-popup>
    </div>
</template>
  
<script>

import { Icon, Popup } from 'vant';
// import rule from './rule.vue'

export default {
    name: 'tvoucher_recommend',
    props: {
        data: {
            type: Array,
            default: () => []
        },
        exchange: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        exchange(val) {
            if (val) {
                this.ruleFlag = false;
            }
        }
    },
    components: {
        [Icon.name]: Icon,
        [Popup.name]: Popup,
        // rule
    },
    data() {
        return {
            ruleFlag: false,
            rule: ''
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        ruleEvent(rule) {
            this.rule = rule;
            this.ruleFlag = true;
        },
        go(item) {
            this.$emit('recommend', item);
        },
    }
}
</script>
<style lang="less" scoped>
.recommend {
    position: relative;
    background: #fff;
    border-radius: 12px;
    width: 100%;
    padding-top: 16px;
    padding-bottom: 2px;
    margin-top: 10px;

    &-cell {
        height: 90px;
        margin: 0 14px 10px 14px;
        background: url('https://file.40017.cn/appresource/image/voucher/recom_cell_bg.png') no-repeat;
        background-size: 100% 100%;
        display: flex;

        &-right {
            width: 27%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            &-price {
                font-family: DINPro-Bold;
                font-weight: 700;
                font-size: 30px;
                color: #FF633B;
                letter-spacing: -0.77px;
                line-height: 28px;
                position: relative;
            }

            &-price::before {
                content: '¥';
                font-size: 14px;
                margin-right: 1px;
                margin-left: 5px;
            }

            &-max {
                font-family: PingFangSC-Regular;
                font-weight: 600;
                font-size: 9px;
                color: #FF633B;
                width: 13px;
                margin-left: 2px;
            }
        }

        &-left {
            position: relative;
            width: 73%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            &-info {
                position: relative;
                margin-left: 18px;
                margin-right: 5px;

                &-name {
                    font-family: PingFangSC-SNaNpxibold;
                    font-weight: 600;
                    font-size: 16px;
                    color: #333333;
                    letter-spacing: -0.39px;
                    line-height: 18px;

                    span {
                        margin-left: 4px;
                        color: #888;
                    }
                }

                &-limit {
                    margin-top: 6px;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 12px;
                    color: #B2B2B2;
                    letter-spacing: -0.29px;
                    line-height: 16px;
                }
            }

            &-btn {
                width: 64px;
                height: 28px;
                line-height: 28px;
                background: #FF6257;
                border-radius: 14px;
                margin-right: 24px;
                text-align: center;
                flex-shrink: 0;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 12px;
                color: #FFFFFF;
                letter-spacing: -0.29px;
            }
        }
    }

    .pop {
        background-color: transparent;
        width: 85%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content {
            width: 100%;
            min-height: 300px;
            background-color: #fff;
            border-radius: 12px;
            display: flex;
            align-items: center;
            flex-direction: column;
            position: relative;

            &-title {
                margin-top: 30px;
                font-size: 18px;
                font-family: PingFangSC-SNaNpxibold;
                font-weight: 600;
                color: #333;
                letter-spacing: 0;
            }

            &-rule {
                margin: 12px 15px 20px 15px;
                max-height: 300px;
                overflow: auto;
            }
        }

        .close {
            margin-top: 20px;
        }
    }
}
</style>
  